import type { RealtimePresencePayload } from '@klareospace/pharos-lib-types';
import type { ApiClient } from '../api/api-client';

export interface PresenceApi {
  enter: (presenceUrl: string, page: string) => Promise<void>;
  leave: (presenceUrl: string, page: string) => Promise<void>;
}

export function createPresenceApi(client: ApiClient): PresenceApi {
  return {
    enter: async (presenceUrl: string, page: string): Promise<void> => {
      const payload: RealtimePresencePayload = { page, state: 'enter' };
      await client.instance.post(presenceUrl, payload);
    },
    leave: async (presenceUrl: string, page: string): Promise<void> => {
      const payload: RealtimePresencePayload = { page, state: 'leave' };
      await client.instance.post(presenceUrl, payload);
    },
  };
}
